module.exports = __webpack_public_path__ + "img/icon_arms.fe699243.svg";